import { useCallback } from 'react';

import { useSidebarEvents } from '../../service';
import { useMainActions } from '../../store';
import { GENERATION_TOOL_POPUP, useGenerationToolPopup } from 'src/services/popup';
import { SIDEBAR_TAB_TYPE } from 'src/views/GenerationToolPopup/const';
import { useCreateProject } from 'src/services';
import { PROJECT_TYPE } from 'src/data/project';
import { GENERATION_TOOL } from 'src/data/generationTool';

export const useHandlers = () => {
  const { trackNavigationItemClicked } = useSidebarEvents();
  const mainActions = useMainActions();
  const openGenerationToolPopup = useGenerationToolPopup();
  const createProject = useCreateProject();

  const handleGenerationToolPopupCardClick = useCallback(
    ({ tool, freestyleToolId, customMultiPromptId, customMultiPromptGroup }) => {
      if (tool === GENERATION_TOOL.blogDescription) {
        createProject(PROJECT_TYPE.blogPostBuilder);
        return;
      }

      createProject(PROJECT_TYPE.document, {
        generationTool: tool,
        freestyleGenerationToolId: freestyleToolId,
        customMultiPromptId,
        customMultiPromptGroup,
      });
    },
    [createProject]
  );

  const handleOpenBlogWizardClick = useCallback(() => {
    createProject(PROJECT_TYPE.blogPostBuilder, {
      generationTool: GENERATION_TOOL.blogDescription,
    });
  }, [createProject]);

  const handleToggleMenu = useCallback(
    (menuItem) => {
      mainActions.toggleMenuItem(menuItem?.id);
    },
    [mainActions]
  );

  const handleToggleCollapse = useCallback(
    (collapseItem) => {
      mainActions.toggleCollapseItem(collapseItem?.id);
    },
    [mainActions]
  );

  const handleOpenGenerationToolPopup = useCallback(
    (documentOnly) =>
      openGenerationToolPopup({
        selectedTabType: SIDEBAR_TAB_TYPE.mostPopular,
        onSubmit: handleGenerationToolPopupCardClick,
        withBlog: !documentOnly,
      }),
    [openGenerationToolPopup, handleGenerationToolPopupCardClick]
  );

  const handleLinkClick = useCallback(
    (linkItem) => {
      trackNavigationItemClicked(linkItem.label);

      if (!linkItem.isChildItem && !linkItem.disableNavigation) {
        mainActions.collapseAll();
      }
      if (linkItem.popupKey === GENERATION_TOOL_POPUP) {
        handleOpenGenerationToolPopup();
      }
    },
    [mainActions, trackNavigationItemClicked, handleOpenGenerationToolPopup]
  );

  return {
    handleToggleMenu,
    handleToggleCollapse,
    handleLinkClick,
    handleOpenGenerationToolPopup,
    handleOpenBlogWizardClick,
  };
};
